var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lista),function(cp){return _c('b-list-group',{key:cp.Id,attrs:{"flush":_vm.flush}},[_c('b-list-group-item',{attrs:{"href":"#"}},[_c('b',[_vm._v(_vm._s(cp.CargoEstablecimiento.CargoString))]),_vm._v("-"+_vm._s(cp.CargoEstablecimiento.UnidadEducativaNivelString))])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21246916","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CargoPersonalList.vue
// module id = VQzd
// module chunks = 1